import { render, staticRenderFns } from "./simplifyShopsHireLog.vue?vue&type=template&id=8a88f3ba&scoped=true"
import script from "./simplifyShopsHireLog.vue?vue&type=script&lang=js"
export * from "./simplifyShopsHireLog.vue?vue&type=script&lang=js"
import style0 from "./simplifyShopsHireLog.vue?vue&type=style&index=0&id=8a88f3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a88f3ba",
  null
  
)

export default component.exports